import React from "react";

export default ({ width = 26, ...props }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox={`0 0 ${width} ${width}`}
      fill="none"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M26 12.0571C26 10.1626 24.6107 8.58712 22.7977 8.29423V2.96593C22.7977 2.3246 22.4665 1.7494 21.9119 1.42738C21.3573 1.10527 20.6936 1.10293 20.1366 1.42078L10.8534 6.7199H3.81232C1.71021 6.7199 0 8.4301 0 10.5322V13.5821C0 15.6842 1.71021 17.3944 3.81232 17.3944H3.94524L7.381 23.6646C7.77001 24.3746 8.51463 24.8157 9.32421 24.8157C9.99295 24.8157 10.6189 24.5184 11.0415 24.0002C11.4641 23.4819 11.6293 22.8089 11.4947 22.1539L10.5167 17.3944H10.8534L20.1366 22.6935C20.4131 22.8513 20.7159 22.9302 21.0187 22.9302C21.3257 22.9302 21.6327 22.849 21.9119 22.6869C22.4665 22.3649 22.7977 21.7897 22.7977 21.1483V15.82C24.6107 15.5272 26 13.9517 26 12.0571ZM21.1462 21.3682C21.0989 21.3956 21.0032 21.4323 20.8926 21.3692L11.8182 16.1892V7.92505L20.8926 2.74517C21.0031 2.68209 21.0989 2.71869 21.1462 2.74614C21.1934 2.77359 21.2727 2.8386 21.2727 2.96593V21.1484C21.2727 21.2757 21.1934 21.3407 21.1462 21.3682ZM9.85967 23.0365C9.78225 23.1315 9.60968 23.2908 9.32421 23.2908C9.07179 23.2908 8.83964 23.1533 8.71836 22.9319L5.68411 17.3944H8.95991L10.001 22.4609C10.0584 22.7405 9.93708 22.9415 9.85967 23.0365ZM3.58358 14.3445C4.00466 14.3445 4.34604 14.0031 4.34604 13.5821C4.34604 13.161 4.00466 12.8196 3.58358 12.8196H1.52493V11.2947H3.58358C4.00466 11.2947 4.34604 10.9533 4.34604 10.5322C4.34604 10.1111 4.00466 9.76975 3.58358 9.76975H1.65607C1.97082 8.88229 2.81832 8.24482 3.81232 8.24482H10.2933V15.8695H3.81232C2.81832 15.8695 1.97082 15.232 1.65607 14.3445H3.58358ZM22.7977 14.2613V9.85301C23.7636 10.1207 24.4751 11.0071 24.4751 12.0572C24.4751 13.1073 23.7636 13.9936 22.7977 14.2613Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
